import { render, staticRenderFns } from "./MiniFormQuestion.vue?vue&type=template&id=2badf5bd&scoped=true"
import script from "./MiniFormQuestion.vue?vue&type=script&lang=js"
export * from "./MiniFormQuestion.vue?vue&type=script&lang=js"
import style0 from "./MiniFormQuestion.vue?vue&type=style&index=0&id=2badf5bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2badf5bd",
  null
  
)

export default component.exports